import { useDemoMode } from '../contexts/DemoModeContext';

export const useReadOnly = () => {
  const { isDemoMode } = useDemoMode();
  
  const showDemoAlert = () => {
    alert('🎯 Demo Mode: This action is not allowed in demo mode. Please contact the administrator for full access.');
  };

  const isReadOnly = isDemoMode;

  return {
    isReadOnly,
    showDemoAlert,
    canEdit: !isReadOnly,
  };
};
